"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const Button_1 = require("@Components/Buttons/Button");
const navigation_1 = __importDefault(require("@App/navigation"));
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const CancelUploadModal = (props) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { bulkUploadReviewModalIsOpen, closeBulkUploadReviewModal } = props;
    const closeModalAndCancel = () => {
        closeBulkUploadReviewModal();
        navigate(navigation_1.default.rightholder.createWork.bulk.root(rightsholderStore.currentRightsholderId));
    };
    return (react_1.default.createElement(ModalPortal_1.default, { isOpen: bulkUploadReviewModalIsOpen, onClose: closeBulkUploadReviewModal },
        react_1.default.createElement(Popup_1.default, { onClose: closeBulkUploadReviewModal, className: 'cancel-confirmation' },
            react_1.default.createElement("div", { className: 'info-head' },
                react_1.default.createElement("h3", null, "Are you sure you want to cancel?"),
                react_1.default.createElement("p", null, "Canceling will remove all your bulk work upload progress. This may be a good idea if you want to start over and make edits directly in your bulk file before re-uploading.")),
            react_1.default.createElement("div", { className: "search-confirm-popup-content" },
                react_1.default.createElement("div", { className: 'buttons-block' },
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'secondary', onClick: closeBulkUploadReviewModal }, "No"),
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => closeModalAndCancel() }, "Yes, I want to cancel"))))));
};
exports.default = CancelUploadModal;
